// @flow
import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import ListItem from '@material-ui/core/ListItem';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import { ListItemIcon } from '@material-ui/core';

type Props = {
  micIdSelected: string,
  availableMics: Array<any>,
  setMicSelected: Function,
};

type State = {};

class MicSelector extends React.Component<Props, State> {
  handleChange = event => {
    const { setMicSelected } = this.props;
    setMicSelected(event.target.value);
  };

  handleClick = () => {
    if (navigator.mediaDevices) {
      navigator.mediaDevices.getUserMedia({ audio: true });
    }
  };

  componentDidUpdate(prevProps) {
    const { availableMics: prevAvailableMics } = prevProps;
    const { availableMics, setMicSelected } = this.props;
    if (availableMics.length - prevAvailableMics.length === 1) {
      let newMicValue;
      availableMics.forEach(newMic => {
        let micFound = false;
        prevAvailableMics.forEach(prevMic => {
          if (prevMic.value === newMic.value) {
            micFound = true;
          }
        })
        if (!micFound) {
          newMicValue = newMic.value;
        }
      })
      setMicSelected(newMicValue);
    }
  }

  render() {
    const { micIdSelected, availableMics } = this.props;
    if (!micIdSelected) {
      return <div />;
    }
    const selectedMic = availableMics.find(mic => mic.value === micIdSelected);
    if (!selectedMic || !selectedMic.label) {
      return <div />;
    }
    return (
      <div>
        <ListItem key="mic_selected" role={undefined} dense>
          <ListItemIcon>
            <i className="material-icons">settings_voice</i>
          </ListItemIcon>
          <Select
            value={micIdSelected}
            onChange={this.handleChange}
            style={{ marginLeft: 16, overflow: 'hidden' }}
            disabled={selectedMic && availableMics.length < 2}
          >
            {availableMics.map(x => (
              <MenuItem key={x.value} value={x.value}>
                {x.label}
              </MenuItem>
            ))}
          </Select>
        </ListItem>
      </div>
    );
  }
}
export default withTranslation()(withTheme(MicSelector));
